import React, { createContext, useContext } from 'react';

export interface ExamInsightsState {
  /** The full analysis of this attempt is still behind the plan. */
  locked: boolean;
  /** Unlock with a plan credit, or go to the plans when there is none. */
  requestUnlock: () => void;
  /** An unlock is being sent. */
  unlocking: boolean;
  /** The last unlock failed for a reason a plan would not fix (network, server): worth a retry. */
  failed: boolean;
}

const NOT_GATED: ExamInsightsState = { locked: false, requestUnlock: () => undefined, unlocking: false, failed: false };

const ExamInsightsContext = createContext<ExamInsightsState>(NOT_GATED);

export function ExamInsightsProvider({ value, children }: { value: ExamInsightsState; children: React.ReactNode }) {
  return <ExamInsightsContext.Provider value={value}>{children}</ExamInsightsContext.Provider>;
}

/** Outside a gated result page this reports "not locked", so shared review components behave as before. */
export function useExamInsights(): ExamInsightsState {
  return useContext(ExamInsightsContext);
}
